<template lang='pug'>
  v-card(@click='goToDashboard')
    v-card-title
      v-row(no-gutters)
        v-col(cols='10' no-gutters)
          .text-h5.font-weight-light.text-ellipsis {{dashboard.name}}
          .text-caption.font-weight-light.text-ellipsis(v-if='gitMode') {{dashboard.gitBranch}}
          .text-caption.font-weight-light.text-ellipsis(v-else) {{dashboard.baseUrl}}
        v-spacer
        v-menu(offset-y left)
          template(v-slot:activator='{on}')
            v-btn.mr-1(text icon v-on='on' @mousedown.stop)
              v-icon more_vert
          v-list
            v-list-item(@click.stop='() => $emit("delete", dashboard)')
              v-list-item-title Delete&nbsp;
                strong {{dashboard.name}}
    v-card-text
      v-row(no-gutters).mt-4.mb-4
        v-col.text-center
          .text-h2.green--text.accent-4 {{dashboard.passing || 0}}
          .text-subtitle-1.grey--text Passing
        v-col.text-center
          .text-h2.deep-orange--text.text--darken-3 {{dashboard.failing || 0}}
          .text-subtitle-1.grey--text Failing
    bionic-metrics-summary-chart(:total='dashboard.total' :passing='dashboard.passing' :failing='dashboard.failing')
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import BionicMetricsSummaryChart from './SummaryChart';
import UtilMixin from '../mixins/util.mixin';

export default {
  name: 'BionicMetricsSummaryCard',
  components: {BionicMetricsSummaryChart},
  mixins: [UtilMixin],
  props: {
    dashboard: {
      type: Object
    }
  },
  computed: {
    ...mapGetters({
      gitBranch: 'getGitBranch',
      gitMode: 'getGitMode'
    })
  },
  methods: {
    async goToDashboard() {
      console.log('Going to dashboard');
      if (this.gitMode) {
        const branch = this.dashboard.gitBranch;
        if (this.gitBranch !== branch) {
          console.log(`Need to change branch to ${branch}`);
          await this.gitChangeBranch({branch, reload: false});
        }
        this.to(`/dashboard/${this.dashboard.gitBranch}`);
      } else this.to(`/dashboard/${this.dashboard.guid}`);
    },
    ...mapActions({
      gitChangeBranch: 'gitChangeBranch'
    })
  }
};
</script>

<style scoped>
</style>
